import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { PersonaData } from '@/shared/api/persona-service';

type SelectedPersonaState = {
  selectedPersona: PersonaData | null;
  setSelectedPersona: (persona: PersonaData | null) => void;
  clearSelectedPersona: () => void;
};

export const useSelectedPersonaStore = create<SelectedPersonaState>()(
  persist(
    (set) => ({
      selectedPersona: null,

      setSelectedPersona: (persona) => set({ selectedPersona: persona }),

      clearSelectedPersona: () => set({ selectedPersona: null }),
    }),
    {
      name: 'selected-persona-storage',
      partialize: (state) => ({ selectedPersona: state.selectedPersona }),
    },
  ),
);
